import {Component, Input, OnInit} from '@angular/core';
import {UserRoleModel} from '../../../../shared/dto/user-role.model';
import {UserRoleService} from '../../../../shared/service/userrole.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserRolesComponent} from '../user-roles.component';
import {UserRolePopupComponent} from '../user-role-popup/user-role-popup.component';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";

@Component({
  selector: 'app-user-roles-search-table',
  templateUrl: './user-roles-search-table.component.html',
  styleUrls: ['./user-roles-search-table.component.scss']
})
export class UserRolesSearchTableComponent implements OnInit {
  @Input() items: UserRoleModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  public userRoles: UserRoleModel[] = [];

  constructor(private userRoleService: UserRoleService,
              public modalService: NgbModal,
              private userRoleMgt: UserRolesComponent) { }

  ngOnInit() {
    this.loadUserRoles();
  }


  loadUserRoles() {
    this.userRoleService.getAllUserRoles().subscribe(
      (data: UserRoleModel[]) => {
        this.userRoles = data;
      }
    );
  }

  onClickUpdate(Item) {
    const modalRef = this.modalService.open(UserRolePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update User Role";
    modalRef.componentInstance.userRoleMgtCopy_ = Item;
    modalRef.componentInstance.userRoleCode = Item.userRoleCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.userRoleCategory = Item.userRoleCategoryCode;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.userRoleMgt.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onClickView(Item) {
    const modalRef = this.modalService.open(UserRolePopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View User Role";
    modalRef.componentInstance.userRoleCode = Item.userRoleCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.userRoleCategoryName = Item.userRoleCategoryCode;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;

  }

  onDelete(Item){
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.userRoleService.deleteUserRole(Item.userRoleCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadUserRoles();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
            }
          );
        }
      }, reason => {
      }
    );
  }
}
